import { useTranslation } from 'react-i18next'

import {
  EMPTY_STRING,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { isClipboardWriteSupported } from '../../../utils/clipboard'
import { getQaSelector } from '../../../utils/common'
import Button, { BUTTON_HEIGHT_24 } from '../../Button'
import { ICON_HEIGHT_16 } from '../../Icon'
import { GRETA_CLIPBOARD_IGNORE_ATTRIBUTE } from '../GretaAIChat.constants'

import {
  QA_NAME_GRETA_AI_CHAT_CODE_BLOCK,
  QA_NAME_GRETA_AI_CHAT_CODE_COPY,
} from './GretaAIChatCodeBlock.constants'
import { useGretaAIChatCodeCopy } from './GretaAIChatCodeBlock.hooks'

import * as styles from './GretaAIChatCodeBlock.module.css'

import CopyIcon from '../../../icons/copy.svg'
import DoneIcon from '../../../icons/done.svg'

function GretaAIChatCodeBlock({
  children,
  className = styles.codeBlock,
  code,
}) {
  const { t } = useTranslation()

  const { copied, handleCopy } = useGretaAIChatCodeCopy(code)

  const canCopy = code && isClipboardWriteSupported()

  const qaProps = getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_CODE_BLOCK })

  return (
    <div {...qaProps} className={className}>
      <pre className={styles.pre}>{children}</pre>

      {canCopy ? (
        <Button.Icon
          isGrey
          Icon={copied ? DoneIcon : CopyIcon}
          beforeIconProps={{ height: ICON_HEIGHT_16 }}
          className={styles.copyButton}
          dataProps={{ [GRETA_CLIPBOARD_IGNORE_ATTRIBUTE]: EMPTY_STRING }}
          height={BUTTON_HEIGHT_24}
          qaName={QA_NAME_GRETA_AI_CHAT_CODE_COPY}
          tooltip={copied ? t('Greta.CopiedKey') : t('Greta.CopyCodeKey')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.left}
          onClick={handleCopy}
        />
      ) : null}
    </div>
  )
}

export default GretaAIChatCodeBlock
